import React, { useEffect, useState } from "react";
import cn from "classnames";
import styles from "./styles.css";
function useStickyHeader() {
    const [isSticky, setSticky] = useState(false);
    useEffect(() => {
        const handleScroll = () => {
            setSticky(window.scrollY > 0);
        };
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return isSticky;
}
function Header({ link, logoSrc, logoAlt, mainTitle }) {
    const isSticky = useStickyHeader();
    return (React.createElement("header", { className: cn(styles.wideContainer, { [styles.sticky]: isSticky }) },
        React.createElement("div", { className: styles.container },
            React.createElement("a", { href: link },
                React.createElement("img", { src: logoSrc, alt: logoAlt })),
            React.createElement("h1", { className: styles.mainTitle }, mainTitle))));
}
export default Header;
